import { render } from "./activate-button.vue?vue&type=template&id=2801aace&lang=pug"
import script from "./activate-button.vue?vue&type=script&lang=js"
export * from "./activate-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__